import { useEffect, useRef } from 'react'
import { BOT_USERNAME } from '../config'

/**
 * Кнопка Telegram Login Widget в режиме редиректа: после подтверждения Telegram возвращает
 * на `data-auth-url` с подписанными полями в query, их читает AuthProvider. Режим колбэка
 * (`data-onauth`) не берём: виджет исполняет его через new Function, а CSP запрещает eval.
 */
export function TelegramLoginButton() {
  const container = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const host = container.current
    if (host === null) return
    const script = document.createElement('script')
    script.src = 'https://telegram.org/js/telegram-widget.js?22'
    script.async = true
    script.dataset.telegramLogin = BOT_USERNAME
    script.dataset.size = 'large'
    script.dataset.radius = '20'
    script.dataset.authUrl = `${window.location.origin}/`
    script.dataset.requestAccess = 'write'
    host.appendChild(script)
    return () => host.replaceChildren()
  }, [])

  return <div ref={container} />
}
